/**
 * Variance Reason Categories
 * Used for categorizing delays and variances in production
 */

export const REASON_CATEGORIES = Object.freeze({
  EQUIPMENT_BREAKDOWN: 'Equipment breakdown',
  OPERATIONAL_ISSUES: 'Operational issues',
  MANPOWER: 'Manpower',
  PLANNING_ERROR: 'Planning error',
  ENGG_UNPLANNED_ACTIVITY: 'Engg-Unplanned activity',
  PLAN_CHANGE: 'Plan change',
  PRODUCT_ISSUE: 'Product issue',
  EQUIPMENT_BREAKDOWN_CASCADING: 'Equipment breakdown-cascading',
  QA: 'QA',
  DISPENSING: 'Dispensing',
  OPERATIONAL_ISSUES_WIP: 'Operational issues - WIP',
  DATA_ENTRY_ERROR: 'Data entry error',
  OTHERS: 'Others',
});

// Array format for dropdowns and iteration
export const REASON_OPTIONS = Object.values(REASON_CATEGORIES);

export default REASON_CATEGORIES;
